import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/ncrInspection'

const ncrInspection = axios.create({
  baseURL
})

interceptorsSetup(ncrInspection)

export default class NCRInspection {
  static async getTable (ncrQuery) {
    const result = await ncrInspection.get('/' + ncrQuery.siteId, {
      params:
      {
        start: ncrQuery.start,
        end: ncrQuery.end
      }
    })
    return result.data
  }
  static async createNCR (ncr) {
    const result = await ncrInspection.post('/', ncr)
    return result.data
  }
  static async updateNCR (ncr) {
    const result = await ncrInspection.post('/update', ncr)
    return result.data
  }
  static async archiveNCR (ncr) {
    const result = await ncrInspection.put('/archive/' + ncr)
    return result.data
  }
}
